import React from 'react';
import { FallbackProps } from 'react-error-boundary';

import ErrorPage from 'pages/ErrorPage/ErrorPage';

const ErrorBoundaryFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
    return <ErrorPage type={500} errorMsg={error.message} retryHandler={resetErrorBoundary} />;
};

export default ErrorBoundaryFallback;
